import { render, staticRenderFns } from "./YoutubeDashboard.vue?vue&type=template&id=fce3f26c"
import script from "./YoutubeDashboard.vue?vue&type=script&lang=js"
export * from "./YoutubeDashboard.vue?vue&type=script&lang=js"
import style0 from "./YoutubeDashboard.vue?vue&type=style&index=0&id=fce3f26c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports